import React from 'react'
import LoginForm from '../../../../Components/Forms/LoginForm'

function Login() {
    return (
        <section className='login-section mb-4'>
            <div className='container'>
                <h1 className='text-center mb-4 text-uppercase'>FTL Ambassador Login</h1>
                <LoginForm />
            </div>
        </section>
    )
}

export default Login
